import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useBranding } from '../contexts/BrandingContext';
import { BRANDING_ELIGIBLE_PLAN_IDS } from '../utils/branding';
import CompanyBrandingEditor from '../components/CompanyBrandingEditor';

export default function CompanyBrandingPage() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const { company, loading } = useBranding();

  const ownerIds = React.useMemo(() => {
    if (!company) return [];
    return Array.isArray(company.accountOwnerIds)
      ? company.accountOwnerIds
      : company.accountOwnerId
        ? [company.accountOwnerId]
        : [];
  }, [company]);

  const isAccountOwner = user?.uid && ownerIds.includes(user.uid);
  const planId = company?.planId || '';
  const isEligiblePlan = BRANDING_ELIGIBLE_PLAN_IDS.includes(planId);

  if (loading && !company) {
    return (
      <div style={{ padding: 40, background: 'var(--branding-app-surface)', minHeight: '100vh' }}>
        <p style={{ color: '#64748b' }}>Loading…</p>
      </div>
    );
  }

  if (!company) {
    return (
      <div style={{ padding: 40, background: 'var(--branding-app-surface)', minHeight: '100vh' }}>
        <p style={{ color: '#64748b' }}>Company not found.</p>
        <Link to="/home" style={{ color: 'var(--branding-app-primary)' }}>
          Back to settings
        </Link>
      </div>
    );
  }

  if (!isAccountOwner) {
    return (
      <div style={{ padding: 40, background: 'var(--branding-app-surface)', minHeight: '100vh', maxWidth: 560 }}>
        <h1 style={{ fontSize: 22, color: '#1e293b' }}>Company branding</h1>
        <p style={{ color: '#64748b' }}>Only account owners can change company branding.</p>
        <button
          type="button"
          onClick={() => navigate('/home')}
          style={{
            marginTop: 16,
            padding: '8px 16px',
            borderRadius: 8,
            border: '1px solid #cbd5e1',
            background: '#fff',
            cursor: 'pointer',
          }}
        >
          Back to settings
        </button>
      </div>
    );
  }

  if (!isEligiblePlan) {
    return (
      <div style={{ padding: 40, background: 'var(--branding-app-surface)', minHeight: '100vh', maxWidth: 560 }}>
        <h1 style={{ fontSize: 22, color: '#1e293b' }}>Company branding</h1>
        <p style={{ color: '#475569', lineHeight: 1.6 }}>
          Custom <strong>accent colours</strong> (app-wide buttons and links, plus the Home plan strip) are available on{' '}
          <strong>Pro</strong> and <strong>Pro+</strong>. Upgrade your plan to unlock branding.
        </p>
        <button
          type="button"
          onClick={() => navigate('/home')}
          style={{
            marginTop: 16,
            padding: '8px 16px',
            borderRadius: 8,
            border: '1px solid #cbd5e1',
            background: '#fff',
            cursor: 'pointer',
          }}
        >
          Back to settings
        </button>
      </div>
    );
  }

  return (
    <div style={{ padding: 40, background: 'var(--branding-app-surface)', minHeight: '100vh' }}>
      <div style={{ maxWidth: 960, margin: '0 auto' }}>
        <CompanyBrandingEditor showPageChrome onBack={() => navigate('/home')} />
      </div>
    </div>
  );
}
